function siteIsNowVisited() {
	localStorage.setItem("visitsVer2", "1");
}

export default siteIsNowVisited;
